// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-undef */
import * as R from "ramda"
import { get } from "@kiwicom/frontend-common/utils/get"
import pureTranslate from "@kiwicom/frontend-common/services/intl/pureTranslate"
import { brandingTranslationPlaceholdersSelector } from "@kiwicom/frontend-common/services/intl/translateSelector"
import { getLanguageNames } from "@kiwicom/frontend-common/services/staticData"
import type { TranslateFunc } from "@kiwicom/frontend-common/types/translation"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let translationsFromGlobals: Record<string, any> = {}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateGlobals(translations: any) {
  translationsFromGlobals = translations

  R.values(get(["SP_GLOBALS", "SKYPICKER_CURRENCIES"], window)).forEach((currency) => {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    translationsFromGlobals[`currency.${currency.id}`] = currency.format
  })

  // @ts-expect-error: Flow to TS migration.
  const langNames = getLanguageNames(window.__INITIAL_STATE__)
  Object.keys(langNames).forEach((language) => {
    translationsFromGlobals[`language.${language}`] = langNames[language]
  })
}

/**
 * @deprecated - use `formatMessage` function from react-intl
 */
const translate: TranslateFunc = (rawKey, values, passedOptions = {}) => {
  // Normalize args
  // ---
  const key = rawKey.toLowerCase()
  // Important when we use error codes in translation keys, eg. common.payment_error.CARD_FUNDS

  let options = { ...passedOptions }

  if (options.showKey) return key

  // TODO: Remove condition when not needed
  let data = values || {}
  const store = typeof window !== "undefined" && get("reduxStore", window)
  if (store) {
    const state = store.getState()
    if (state) {
      options.translations = state.translations
    }
    data = Object.assign(data, brandingTranslationPlaceholdersSelector(state))
    // Important: Do not throw if condition doesn't pass, it's not critical to run on Node
  }

  // Deprecated behaviour, third argument was defaultShow
  if (typeof options === "string") {
    // TODO: Call cuckoo.deprecated
    const oldThirdArg = options // String, primitive value will be copied, not referenced
    options = {
      defaultShow: oldThirdArg,
    }
  }

  let translations = options.translations ? options.translations : translationsFromGlobals
  // @ts-expect-error: Flow to TS migration.
  if (typeof NEW_TRANSLATIONS !== "undefined") {
    // @ts-expect-error: Flow to TS migration.
    translations = R.mergeDeepRight(translations, NEW_TRANSLATIONS)
  }

  const translated = pureTranslate(key, data, {
    ...options,
    translations,
    language: data.language,
  })

  return translated
}

export default translate
